/**
 * @license
 * Copyright 2017 Google Inc.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { registerDefaultCredentialsProvider } from "#src/credentials_provider/default_manager.js";
import { credentialsKey } from "#src/datasource/brainmaps/api.js";
import { BrainmapsCredentialsProvider } from "#src/datasource/brainmaps/credentials_provider.js";

// Specifies the Google Brainmaps API oauth2 client id to use.
declare const NEUROGLANCER_BRAINMAPS_CLIENT_ID: string | undefined;

if (typeof NEUROGLANCER_BRAINMAPS_CLIENT_ID !== "undefined") {
  registerDefaultCredentialsProvider(
    credentialsKey,
    () => new BrainmapsCredentialsProvider(NEUROGLANCER_BRAINMAPS_CLIENT_ID!),
  );
}
